// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-l_gM"};